module.exports = __webpack_public_path__ + "static/media/mvp-logo.cc1f4b8e.png";